import { CircularProgress, Typography } from "@mui/material";
import { GridOverlay } from "@mui/x-data-grid-pro";

export default function CustomLoadingOverlay() {
  return (
    <GridOverlay>
      <div
        style={{
          alignItems: "center",
          backgroundColor: "rgba(255, 255, 255, 0.75)",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <CircularProgress />
        <Typography style={{ marginTop: 10 }} variant="h6">
          Searching Directory...
        </Typography>
        <Typography style={{ fontWeight: "700", marginTop: 10 }}>One moment! Tailoring your search results.</Typography>
      </div>
    </GridOverlay>
  );
}
